import { RegisteredComponent } from "@builder.io/sdk-react";

export const swdcInternalSearchWrapperBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "SWDC Internal Search Wrapper",
  description:
    "Container for SWDC Internal Search Components (left filter, banner, and results). Place all search-related components inside this wrapper.",
  noWrap: false,
  canHaveChildren: true,
  hideFromInsertMenu: process.env.SITE !== "swdc",
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "searchValue",
      type: "string",
    },
  ],
  defaultStyles: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flexShrink: "0",
    boxSizing: "border-box",
  },
};
